module.exports = __webpack_public_path__ + "img/swipe3.cf70f49a.png";